import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export function useImageModeration() {
  const [isChecking, setIsChecking] = useState(false);
  const { toast } = useToast();

  const moderateImage = async (imageFile: File): Promise<boolean> => {
    setIsChecking(true);
    
    try {
      // Convert image to base64
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onload = () => {
          const base64 = reader.result as string;
          resolve(base64);
        };
        reader.onerror = reject;
      });
      
      reader.readAsDataURL(imageFile);
      const base64Image = await base64Promise;

      const { data, error } = await supabase.functions.invoke('moderate-image', {
        body: { image: base64Image }
      });

      if (error) {
        console.error('Image moderation error:', error);
        // Fail open for better UX
        toast({
          title: "Moderation service unavailable",
          description: "Your image will be uploaded but may be reviewed later.",
        });
        return true;
      }

      if (data?.flagged) {
        toast({
          title: "Image not allowed",
          description: data.message || "Your image contains inappropriate content. Please choose a different image.",
          variant: "destructive",
        });
        return false;
      }

      return true;
    } catch (error: any) {
      console.error('Image moderation error:', error);
      // Fail open for better UX
      return true;
    } finally {
      setIsChecking(false);
    }
  };

  return {
    moderateImage,
    isChecking,
  };
}
